import { cn } from '@nexelem/utils';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { forwardRef } from 'react';

const PopoverPureContent = forwardRef<HTMLDivElement, PopoverPrimitive.PopoverContentProps>(
  ({ className, ...props }, ref) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        className={cn(
          'm-1 flex flex-col items-stretch justify-stretch overflow-hidden rounded-xs bg-surface-primary shadow-small',
          // animations
          'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
          className,
        )}
        {...props}
        ref={ref}
      />
    </PopoverPrimitive.Portal>
  ),
);

PopoverPureContent.displayName = 'PopoverPureContent';

const PopoverTrigger = forwardRef<HTMLButtonElement, PopoverPrimitive.PopoverTriggerProps>(
  ({ children, ...props }, ref) => (
    <PopoverPrimitive.Trigger asChild ref={ref} {...props}>
      {children}
    </PopoverPrimitive.Trigger>
  ),
);

PopoverTrigger.displayName = 'PopoverTrigger';

const PopoverContent = forwardRef<HTMLDivElement, PopoverPrimitive.PopoverContentProps>(
  ({ className, ...props }, ref) => (
    <PopoverPureContent
      align="start"
      className={cn('z-5202 bg-surface-dark p-2 text-t12-sb text-text-primary-inverse', className)}
      {...props}
      ref={ref}
    />
  ),
);

PopoverContent.displayName = 'PopoverContent';

export const Popover = {
  Root: PopoverPrimitive.Root,
  Trigger: PopoverTrigger,
  Anchor: PopoverPrimitive.Anchor,
  PureContent: PopoverPureContent,
  Content: PopoverContent,
};
